'use strict'
import commonService from '@/services/common'

const state = { categories: [], b2cCategories: [], kvConfig: {} }

const actions = {
  async getV3Config ({ commit }) {
    let categories = []
    let b2cCategories = []
    let kvConfig = {}
    try {
      const apiRes = await commonService.getV3Config()
      const { kv, categories: apiCategories } = apiRes.data.data || {}
      kvConfig = kv || {}
      apiCategories.map((item) => {
        if (item.biz_type !== 'b2c') {
          categories.push({
            value: item.value,
            taxiCategoryName: item.taxi_category_name,
            text: item.text,
            html: item.html,
            img: item.img,
            description: item.description,
            tooltip: item.tooltip,
            waitingTime: item.waiting_time,
            '99cuponsEnabled': item.cupons_enabled,
            bizType: item.biz_type,
            tcUrl: item.tc_url
          })
        } else {
          b2cCategories.push({
            value: item.value,
            taxiCategoryName: item.taxi_category_name,
            text: item.text,
            html: item.html,
            img: item.img,
            description: item.description,
            tooltip: item.tooltip,
            waitingTime: item.waiting_time,
            '99cuponsEnabled': item.cupons_enabled,
            bizType: item.biz_type,
            tcUrl: item.tc_url
          })
        }
      })
    } catch (e) {
      console.log(e)
    }
    console.log('getV3Config', categories, b2cCategories, kvConfig)
    commit('getCategories', categories)
    commit('getB2cCategories', b2cCategories)
    commit('getKvConfig', kvConfig)
  }
}

const mutations = {
  getCategories (state, categories) {
    state.categories = categories
  },
  getB2cCategories (state, b2cCategories) {
    state.b2cCategories = b2cCategories
  },
  getKvConfig (state, kvConfig) {
    state.kvConfig = kvConfig
  }
}

const CommonConfig = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default CommonConfig
